// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3epZR","content":"ManualTimeModal_content__3QmXN"};